var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-progress-container" },
    [
      _c("el-progress", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.progress,
            expression: "progress",
          },
        ],
        staticClass: "my-progress",
        attrs: {
          "text-inside": true,
          "stroke-width": 14,
          percentage: _vm.progress,
        },
      }),
      _c(
        "svg",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.progress !== 0 && _vm.progress !== 100,
              expression: "progress!== 0 && progress!== 100",
            },
          ],
          staticClass: "circular",
          attrs: { viewBox: "25 25 50 50" },
        },
        [
          _c("circle", {
            staticClass: "path",
            attrs: { cx: "50", cy: "50", r: "20", fill: "none" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }